import React, { useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useSocial } from '../context/socialProvider';

// Define navigation items with consistent patterns
const navItems = [
  // { name: 'Analytics', path: 'analytics' },
  { name: 'Organic Comments', path: 'allComments' },
  { name: 'Ad Comments', path: 'adComments' },
  { name: 'DMs', path: 'directMessages' },
  { name: 'Posts', path: 'postsview' },
  {
    name: 'Page Settings',
    path: 'settings',
    isSettings: true,
  },
];

const Header = () => {
  const location = useLocation();
  const { providerId, providerName } = useParams<{
    providerId: string;
    providerName: string;
  }>();

  const { currentSocial, availableSocials, switchSocial } = useSocial();

  // Use the provider info from the route if available, otherwise use current social
  let activeProviderId, activeProviderName;

  if (providerId === 'global' || providerName === 'default') {
    activeProviderId = 'global';
    activeProviderName = 'default';
  } else if (providerId && providerName) {
    activeProviderId = providerId;
    activeProviderName = decodeURIComponent(providerName); // Decode for comparison
  } else if (currentSocial) {
    activeProviderId = currentSocial.id.toString();
    activeProviderName = currentSocial.providerName;
  } else {
    activeProviderId = 'global';
    activeProviderName = 'default';
  }

  return (
    <header className="bg-grey border-b border-white border-opacity-20 h-24">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-end">
        <nav className="hidden md:flex items-center gap-20 pb-4">
          {navItems.map((item) => {
            const isFacebookDMs =
              item.name === 'DMs' && currentSocial?.provider === 2;

            let to;
            if (item.isSettings) {
              to =
                activeProviderId !== 'global'
                  ? `/${activeProviderId}/${encodeURIComponent(
                      activeProviderName
                    )}/settings`
                  : `/global/settings`;
            } else {
              to = `/${activeProviderId}/${encodeURIComponent(
                activeProviderName
              )}/${item.path}`;
            }

            // Improved active state detection - normalize paths for comparison
            const pathParts = location.pathname.split('/').filter(Boolean);

            // Decode URL-encoded path parts for comparison
            const decodedPathParts = pathParts.map((part) =>
              decodeURIComponent(part)
            );

            // Special handling for checking active state
            let isActive;
            if (item.name === 'Organic Comments') {
              // Active if on /[id]/[name]/allComments
              isActive =
                decodedPathParts[2] === 'allComments' &&
                decodedPathParts[0] === activeProviderId &&
                (decodedPathParts[1] === activeProviderName ||
                  decodeURIComponent(decodedPathParts[1]) ===
                    activeProviderName);
            } else if (item.isSettings) {
              isActive =
                (decodedPathParts[2] === 'settings' &&
                  decodedPathParts[0] === activeProviderId &&
                  (decodedPathParts[1] === activeProviderName ||
                    decodeURIComponent(decodedPathParts[1]) ===
                      activeProviderName)) ||
                (decodedPathParts[0] === 'global' &&
                  decodedPathParts[1] === 'settings');
            } else {
              isActive =
                decodedPathParts[2] === item.path &&
                decodedPathParts[0] === activeProviderId &&
                (decodedPathParts[1] === activeProviderName ||
                  decodeURIComponent(decodedPathParts[1]) ===
                    activeProviderName);
            }

            // For debugging
            // console.log({
            //   item: item.name,
            //   path: item.path,
            //   activeProviderId,
            //   activeProviderName,
            //   decodedPathParts,
            //   isActive
            // });

            return isFacebookDMs ? (
              <div
                key={item.path}
                className="relative group px-4 py-2 rounded-md text-sm font-medium text-white text-opacity-70 cursor-not-allowed hover:bg-white hover:bg-opacity-10"
              >
                {item.name}
                {/* Tooltip that appears on hover */}
                <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-8 hidden group-hover:block bg-black text-white text-xs rounded p-1 z-10 whitespace-nowrap">
                  Not supported for Facebook currently
                </div>
              </div>
            ) : (
              <Link
                key={item.path}
                to={to}
                className={`px-4 py-2 rounded-md text-sm font-medium ${
                  isActive
                    ? 'bg-violet text-white'
                    : 'text-white text-opacity-70 hover:bg-white hover:bg-opacity-10 hover:text-white'
                }`}
              >
                {item.name}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
};

export default Header;
